import type {ReactNode, RefObject} from 'react'
import {Hero} from '@primer/react-brand'

import type {FlexSuiteBaseHeroProps} from './types'
import {getDescription, getHeading} from './utils'

type HeroContentProps = FlexSuiteBaseHeroProps & {
  'data-testid'?: string
  children?: ReactNode
  imageContainerClassName?: string
  imageContainerRef?: RefObject<HTMLDivElement | null>
  headingClassName?: string
}

export function HeroContent({
  heroHeading,
  heroLabel,
  heroDescription,
  heroCtaOne,
  heroCtaTwo,
  heroTertiaryDescription,
  options,
  children,
  'data-testid': dataTestId,
  imageContainerClassName,
  imageContainerRef,
  headingClassName,
}: HeroContentProps) {
  const {variant, enableAnimation, align} = options
  const trailingComponent = heroTertiaryDescription ? () => getDescription(heroTertiaryDescription) : undefined

  return (
    <Hero
      variant={variant}
      align={align}
      enableAnimation={enableAnimation}
      trailingComponent={trailingComponent}
      data-testid={dataTestId}
      imageContainerClassName={imageContainerClassName}
      imageContainerRef={imageContainerRef}
    >
      {heroLabel && <Hero.Label>{heroLabel}</Hero.Label>}
      <Hero.Heading className={headingClassName}>{getHeading(heroHeading)}</Hero.Heading>
      <Hero.Description>{heroDescription ? getDescription(heroDescription) : null}</Hero.Description>
      <Hero.PrimaryAction href={heroCtaOne.fields.href}>{heroCtaOne.fields.text}</Hero.PrimaryAction>
      {heroCtaTwo && (
        <Hero.SecondaryAction href={heroCtaTwo.fields.href}>{heroCtaTwo.fields.text}</Hero.SecondaryAction>
      )}
      {children}
    </Hero>
  )
}
